"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("fragment", [_vm.isIconfont ? _c("icon-font", _vm._g(_vm._b({}, "icon-font", _vm.customAttrs, false), _vm.$listeners)) : _c("a-icon", _vm._g(_vm._b({}, "a-icon", _vm.customAttrs, false), _vm.$listeners))], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;